import React, { Component } from "react";
import "./Beneficiaries.less";
import Modal from "../Modal/Modal";
import TextInput from "../FormComponents/TextInput/TextInput";
import DateInput from "../FormComponents/DateInput/DateInput";
import SelectInput from "../FormComponents/SelectInput/SelectInput";
import SwitchToggle from "../FormComponents/SwitchToggle/SwitchToggle";
import SubmitButton from "../FormComponents/SubmitButton/SubmitButton";
import { PnpService } from "../../../services/pnp-service";
import { ApiService } from "../../../services/api-service";

class Beneficiaries extends Component {
  constructor(props) {
    super(props);
    this.pnpService = new PnpService();
    this.apiService = new ApiService();

    this.state = {
      beneficiaries: props.beneficiaries || [],
      isModalOpen: false,
      isModalDeleteOpen: false,
      isDuplicateModalOpen: false,
      selectedIndex: null,
      formData: {
        name: "",
        relation: "",
        documentType: "",
        documentNumber: "",
        birthDate: "",
        gender: "",
        compensationUser: false,
        complementaryPlan: false,
        category: "",
      },
      editingIndex: null,
      errors: {},
      documentOptions: [],
      selectedDocumentOption: null,
      categoryOptions: [],
      genderOptions: [],
      relationOptions: [],
    };
  }

  componentDidMount() {
    this.pnpService.getListByTitle(
      "tiposDocumento",
      (list) => {
        this.setState({
          documentOptions: list.map((documentType) => ({
            value: documentType.CSSiglaText,
            label: documentType.CSDocumentoIdentidadText,
            type: documentType.CSTipoChoice,
            length: documentType.CSLongitudNumber,
            range: documentType.CSRangoChoice
          })),
        });
      },
      "/salud"
    );

    this.pnpService.getListByTitle(
      "Categorias",
      (list) => {
        this.setState({
          categoryOptions: list.map((category) => ({
            value: category.CSTituloCategoriaText,
            label: category.Title,
          })),
        });
      },
      "/salud"
    );

    this.pnpService.getListByTitle(
      "Genero",
      (list) => {
        this.setState({
          genderOptions: list.map((gender) => ({
            value: gender.Title,
            label: gender.Title,
          })),
        });
      },
      "/salud/medicina-prepagada"
    );

    this.pnpService.getListByTitle(
      "ParentescoMP",
      (list) => {
        this.setState({
          relationOptions: list.map((relation) => ({
            value: relation.Title,
            label: relation.Title,
          })),
        });
      },
      "/salud/medicina-prepagada"
    );
  }

  clearForm = () => {
    this.setState({
      formData: {
        name: "",
        relation: "",
        documentType: "",
        documentNumber: "",
        birthDate: "",
        gender: "",
        compensationUser: false,
        complementaryPlan: false,
        category: "",
      },
      editingIndex: null,
      errors: {},
    });
  };

  isFormValid = () => {
    const { formData } = this.state;
    const requiredFields = [
      "name",
      "relation",
      "documentType",
      "documentNumber",
      "birthDate",
      "gender",
      "category",
    ];

    return requiredFields.every(field => formData[field]?.trim() !== "");
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let errorMessage = "";

    // Validaciones específicas para ciertos campos
    if (name === "name") {
      const nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
      if (!nameRegex.test(value)) {
        errorMessage = "Solo se permiten letras y espacios.";
      }
    }

    if (name === "documentType") {
      const selectedOption = this.state.documentOptions.find(
        (opt) => opt.value === value
      );

      let birthDateError = "";

      if (this.state.formData.birthDate && selectedOption) {
        const birthDate = new Date(this.state.formData.birthDate);
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        const d = today.getDate() - birthDate.getDate();
        const adjustedAge = m < 0 || (m === 0 && d < 0) ? age - 1 : age;

        if (selectedOption.range === "Mayores" && adjustedAge < 18) {
          birthDateError = "Debe ser mayor de edad.";
        } else if (selectedOption.range === "Menores" && adjustedAge >= 18) {
          birthDateError = "Debe ser menor de edad.";
        }
      }

      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          [name]: value || "",
          documentNumber: "", // limpiar número si se cambia el tipo
        },
        selectedDocumentOption: selectedOption,
        errors: {
          ...prevState.errors,
          [name]: value.trim() === "" ? "Este campo es obligatorio" : "",
          birthDate: birthDateError,
          documentNumber: "", // limpiar errores también
        },
      }));
    }


    if (name === "documentNumber") {
      const { selectedDocumentOption } = this.state;
      if (!selectedDocumentOption) return;

      const maxLength = selectedDocumentOption.length;
      const type = selectedDocumentOption.type; // Ej: "NUMERICO" o "ALFA"

      if (value.length > maxLength) {
        errorMessage = `El número de documento no puede superar los ${maxLength} caracteres.`;
      } else if (type === "NUMERICO" && !/^[0-9]*$/.test(value)) {
        errorMessage = "Solo se permiten números.";
      } else if (type === "ALFA" && !/^[a-zA-Z0-9]*$/.test(value)) {
        errorMessage = "Solo se permiten letras y números.";
      }
    }

    if (name === "birthDate") {
      const { selectedDocumentOption } = this.state;

      if (selectedDocumentOption) {
        const range = selectedDocumentOption.range;
        const birthDate = new Date(value);
        const today = new Date();

        const age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        const d = today.getDate() - birthDate.getDate();

        // Calcular edad exacta (si no ha cumplido años aún)
        const adjustedAge = m < 0 || (m === 0 && d < 0) ? age - 1 : age;

        if (range === "Mayores" && adjustedAge < 18) {
          errorMessage = "Debe ser mayor de edad.";
        } else if (range === "Menores" && adjustedAge >= 18) {
          errorMessage = "Debe ser menor de edad.";
        }
      }
    }

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? checked : value || "",
      },
      errors: {
        ...prevState.errors,
        [name]: errorMessage || (value.trim() === "" ? "Este campo es obligatorio" : ""),
      },
    }));
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { formData, editingIndex, beneficiaries } = this.state;

    if (beneficiaries.length >= 10) return;

    const requiredFields = [
      "name",
      "relation",
      "documentType",
      "documentNumber",
      "birthDate",
      "gender",
      "category",
    ];

    let errors = {};
    let isValid = true;

    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        errors[field] = "Este campo es obligatorio";
        isValid = false;
      }
    });

    if (!isValid) {
      this.setState({ errors });
      return;
    }

    // Validación de duplicado de documento
    const isDuplicate = beneficiaries.some((b, index) => {
      return (
        b.documentNumber === formData.documentNumber &&
        index !== editingIndex // Ignorar si estás editando el mismo
      );
    });

    if (isDuplicate) {
      this.openDuplicateModal();
      return;
    }

    let updatedBeneficiaries;

    if (editingIndex !== null) {
      updatedBeneficiaries = [...beneficiaries];
      updatedBeneficiaries[editingIndex] = { ...formData };
    } else {
      updatedBeneficiaries = [...beneficiaries, { ...formData }];
    }

    this.setState({ beneficiaries: updatedBeneficiaries, editingIndex: null });

    this.clearForm();
    this.toggleModal(false);
    if (this.props.onBeneficiariesChange) {
      this.props.onBeneficiariesChange(updatedBeneficiaries);
    }
  };

  toggleModal = (isOpen = false) => {
    this.setState({ isModalOpen: isOpen, editingIndex: null });
  };

  openModal = (index = null) => {
    if (index !== null) {
      this.setState({
        formData: { ...this.state.beneficiaries[index] },
        editingIndex: index,
        isModalOpen: true,
      });
    } else {
      this.clearForm();
      this.toggleModal(true);
    }
  };

  openDeleteModal = (index) => {
    this.setState({ isModalDeleteOpen: true, selectedIndex: index });
    console.log("isModalDeleteOpen: ", this.state.isModalDeleteOpen);
  };

  closeDeleteModal = () => {
    this.setState({ isModalDeleteOpen: false, selectedIndex: null });
  };

  openDuplicateModal = () => {
    this.setState({ isDuplicateModalOpen: true });
  };

  closeDuplicateModal = () => {
    this.setState({ isDuplicateModalOpen: false });
  };

  confirmDelete = () => {
    const { selectedIndex, beneficiaries } = this.state;
    if (selectedIndex !== null) {
      const updatedBeneficiaries = beneficiaries.filter(
        (_, i) => i !== selectedIndex
      );
      this.setState({
        beneficiaries: updatedBeneficiaries,
        isModalDeleteOpen: false,
        selectedIndex: null,
      });

      if (this.props.onBeneficiariesChange) {
        this.props.onBeneficiariesChange(updatedBeneficiaries);
      }
    }
  };

  render() {
    const { formData, errors, beneficiaries, isModalOpen, isModalDeleteOpen } =
      this.state;

    return (
      <div className="beneficiaries-container">
        <h2 className="title">Añade a tus beneficiarios</h2>
        <p className="description">
          Puedes añadir varios miembros o puedes continuar para agendar contacto
          con un asesor.
        </p>

        {beneficiaries.length > 0 && (
          <div className="beneficiaries-list">
            {beneficiaries.map((beneficiary, index) => (
              <div key={index} className="beneficiary-card">
                <div className="beneficiary-info-container">
                  <div className="beneficiary-info">
                    <i className="fa fa-user-circle"></i>
                    <span>{beneficiary.name}</span>
                  </div>
                  <div className="beneficiary-info">
                    <i className="fa fa-id-card"></i>
                    <span>{beneficiary.documentNumber}</span>
                  </div>
                </div>

                <div className="beneficiary-actions">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      this.openModal(index);
                    }}
                  >
                    Editar <i className="fa fa-pencil"></i>
                  </button>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      this.openDeleteModal(index);
                    }}
                  >
                    Eliminar <i className="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        <Modal
          isOpen={isModalOpen}
          title={
            this.state.editingIndex !== null
              ? "Editar beneficiario"
              : "Añadir beneficiario"
          }
          size="large"
          onClose={() => this.toggleModal(false)}
        >
          <p className="modal-description">
            Completa la información de tu beneficiario
          </p>
          <form className="beneficiary-form mt-2" onSubmit={this.handleSubmit}>
            <div className="container-grid">
              <div className="form-group">
                <TextInput
                  label="Nombre del Beneficiario"
                  name="name"
                  value={formData.name}
                  onChange={this.handleChange}
                  required
                  error={errors.name}
                />
              </div>
              <div className="form-group">
                <SelectInput
                  label="¿Qué relación tiene contigo?"
                  name="relation"
                  value={formData.relation}
                  onChange={this.handleChange}
                  options={this.state.relationOptions}
                  required
                  error={errors.relation}
                />
              </div>
              <div className="form-group">
                <SelectInput
                  label="Tipo de documento"
                  name="documentType"
                  value={formData.documentType}
                  onChange={this.handleChange}
                  options={this.state.documentOptions}
                  required
                  error={errors.documentType}
                />
              </div>
              <div className="form-group">
                <TextInput
                  label="Número de documento"
                  name="documentNumber"
                  value={formData.documentNumber}
                  onChange={this.handleChange}
                  required
                  error={errors.documentNumber}
                />
              </div>
              <div className="form-group">
                <DateInput
                  label="Fecha de nacimiento"
                  name="birthDate"
                  value={formData.birthDate}
                  onChange={this.handleChange}
                  required
                  error={errors.birthDate}
                />
              </div>
              <div className="form-group">
                <SelectInput
                  label="Género"
                  name="gender"
                  value={formData.gender}
                  onChange={this.handleChange}
                  options={this.state.genderOptions}
                  required
                  error={errors.gender}
                />
              </div>
              <div className="form-group">
                <span>Caja de compensación Compensar</span>
                <SwitchToggle
                  name="compensationUser"
                  checked={formData.compensationUser}
                  onChange={this.handleChange}
                  labelOff="No"
                  labelOn="Sí"
                />
              </div>
              <div className="form-group">
                <span>Plan Complementario de Compensar</span>
                <SwitchToggle
                  name="complementaryPlan"
                  checked={formData.complementaryPlan}
                  onChange={this.handleChange}
                  labelOff="No"
                  labelOn="Sí"
                />
              </div>
              <div className="form-group">
                <SelectInput
                  label="Categoría caja de compensación"
                  name="category"
                  value={formData.category}
                  onChange={this.handleChange}
                  options={this.state.categoryOptions}
                  required
                  error={errors.category}
                />
              </div>
            </div>

            <div className="button-container">
              <button
                type="button"
                className="cancel-btn"
                onClick={(e) => {
                  e.preventDefault();
                  this.toggleModal(false);
                }}
              >
                Cancelar
              </button>
              <SubmitButton disabled={!this.isFormValid()}>
                <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
                {this.state.editingIndex !== null ? "Guardar" : "Añadir al plan"}
              </SubmitButton>

            </div>
          </form>
        </Modal>

        {/* Modal de confirmación */}
        <Modal
          isOpen={isModalDeleteOpen}
          title="¿Quieres eliminar este beneficiario?"
          size="large"
          onClose={this.closeDeleteModal}
        >
          <p className="modal-description">Esta acción no se puede deshacer.</p>

          <div className="row modalDelete">
            <button className="cancel-btn" onClick={this.closeDeleteModal}>
              Cancelar
            </button>
            <button className="continue-btn" onClick={this.confirmDelete}>
              <i className="fa fa-trash-o" aria-hidden="true"></i>
              Sí, eliminar
            </button>
          </div>
        </Modal>

        {/* modal de documento duplicado */}
        <Modal
          isOpen={this.state.isDuplicateModalOpen}
          title="Documento duplicado"
          size="large"
          onClose={this.closeDuplicateModal}
        >
          <p className="modal-description">Ya existe un beneficiario con este número de documento.</p>

          <div className="row modalDelete">
            <button className="continue-btn" onClick={this.closeDuplicateModal}>
              <i className="fa fa-times-circle" aria-hidden="true"></i>
              Cerrar
            </button>
          </div>
        </Modal>

        <button
          className="add-beneficiary-btn"
          onClick={(e) => {
            e.preventDefault();
            this.openModal();
          }}
          disabled={beneficiaries.length >= 10}
        >
          <i className="fa fa-plus" aria-hidden="true"></i>
          Añadir beneficiario
        </button>
        <button
          className="continue-btn"
          onClick={(e) => {
            e.preventDefault();
            this.props.onNextStep(3);
          }}
        >
          <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
          Continuar
        </button>
      </div>
    );
  }
}

export default Beneficiaries;
